export default __webpack_public_path__ + "static/media/brasil-svg.cfd56a92.svg";